export class DataClassesCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<DataClass>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataClassesCondition.attributeTypeMap;
    }
    constructor() {
    }
}
